export enum FolderItemType {
  File = 1,
  Folder = 2,
  DocumentInbox = 3
}
